import * as React from 'react';
import {NonLoggedBG} from "../../../default/components/NonLoggedBG/LiveNonLoggedBG";
const s = require('./SportappNonLoggedBG.scss') as {
  root:string;
};

export class SportappNonLoggedBG extends NonLoggedBG {
  render() {
    return (
      <div className={s.root + ' ' + this.props.className}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/themes/sportapp/components/NonLoggedBG/SportappNonLoggedBG.tsx